// IIFE - Immediately Invoked Function Expression
(function($, window, document) {

    // The $ is now locally scoped 

    // Listen for the jQuery ready event on the document
    $(function() {

        // The DOM is ready!

    });

  	var headerSticky = document.querySelectorAll(".has-sticky");
    if (headerSticky.length) { 
    	var headerHeight = headerSticky[0].offsetHeight;
    	window.onscroll = function() {
        /*console.log(window.innerWidth)*/
      	var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
      	if (scrollPosition > headerHeight && window.innerWidth > 1200) {
      			headerSticky[0].classList.add('sticky');
      	}else{
      			headerSticky[0].classList.remove('sticky');
      	}
    	};
    }
    

    // Window Resize implement data attr on offcanvas menu
    var windowWidthCheckScroll = function(event) {
      /*var header = document.querySelectorAll(".dynamic-header");*/
       /* $(window).on(event, function() {
            if ($(window).width() < 769) {
                console.log('mobile');
            } else {
                console.log('desk')
                console.log(headerHeight )
                var body = $('body');
                $(window).scroll(function() {
                    if ($(this).scrollTop() > headerHeight) {
                        body.addClass('bri-header-fixed');
                    } else {

                        body.removeClass('bri-header-fixed');
                    }
                });
            }
        });*/
    }

    windowWidthCheckScroll('resize');
    windowWidthCheckScroll('load');

    $('input').on('focus blur', function() {
      $(this).closest( 'form' ).toggleClass('focus');
    });

    $('#department-selector').change(function(){
      var str = "";
      $( "#department-selector option:selected" ).each(function() {
        str += $( this ).text();
      });
      $(this).closest('form').find('.search-dept-label-val').text( str );
      $(this).closest('form').find('input').focus();
    });


  	/*Highlight*/
    var hgBanner =  $('#highlight-slick'); 

  	if (hgBanner.length) {
  		var currentSlide;
  		var slidesCount;
  		

  		hgBanner.slick({
        autoplay: false,
        autoplaySpeed: 6000,
        speed: 500,
        fade: false,
        cssEase: 'linear', 
        dots: false,
        arrows: true,
        prevArrow:"<a class='slick-prev slick-hg-prev'><span class='iconify' data-icon='ic:outline-keyboard-arrow-left' data-inline='false'></span></a>",
        nextArrow:"<a class='slick-next slick-hg-next'><span class='iconify' data-icon='ic:outline-keyboard-arrow-right' data-inline='false'></span></a>",
        responsive: [
            {
              breakpoint: 768,
              settings: {
                /*dots: true,*/
                adaptiveHeight: true
              }
            },
            {
              breakpoint: 415,
              settings: {
                /*arrows: false,*/
                adaptiveHeight: true
              }
            }
        ] 
      });

    }

    /*Daily offers products Carousel*/
    var dailySlick =  $('#daily-products-slick'); 

    if (dailySlick.length) {
      dailySlick.slick({
        /*slidesToShow: 3,*/
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: false,
        infinite: true,
        /*prevArrow:"<a class='slick-prev slick-hg-prev'><span class='iconify' data-icon='ic:outline-keyboard-arrow-left' data-inline='false'></span></a>",
        nextArrow:"<a class='slick-next slick-hg-next'><span class='iconify' data-icon='ic:outline-keyboard-arrow-right' data-inline='false'></span></a>",*/
        responsive: [
            {
              breakpoint: 1025,
              settings: {
                /*arrows: false,*/
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 992,
              settings: {
                /*arrows: false,*/
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 768,
              settings: {
                /*arrows: false,*/
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 415,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
              }
            }
            /*{
              breakpoint: 380,
              settings: {
                arrows: false,
              }
            }*/
        ] 

      });

      // Custom carousel nav
      $('.carousel-prev').click(function(){ 
        $(this).parent().find('.slick-slider').slick('slickPrev');
      } );
      
      $('.carousel-next').click(function(e){
        e.preventDefault(); 
        $(this).parent().find('.slick-slider').slick('slickNext');
      } );


    }

    var productsSlider = $(".-products-slider ul");
    if (productsSlider.length) {
        productsSlider.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 6000,
          arrows: true,
          prevArrow:"<a class='slick-prev slick-hg-prev'><span class='iconify' data-icon='ic:outline-keyboard-arrow-left' data-inline='false'></span></a>",
          nextArrow:"<a class='slick-next slick-hg-next'><span class='iconify' data-icon='ic:outline-keyboard-arrow-right' data-inline='false'></span></a>",
          responsive: [
            {
                breakpoint: 1025,
                settings: {
                  /*arrows: false,*/
                  slidesToShow: 3,
                  slidesToScroll: 1,
                }
              },
              {
                breakpoint: 992,
                settings: {
                  /*arrows: false,*/
                  slidesToShow: 2,
                  slidesToScroll: 1,
                }
              },
              {
                breakpoint: 768,

                settings: {
                  slidesToShow: 1,
                }
              },
              {
                breakpoint: 480,
                 settings: "unslick"
                /*settings: {
                  slidesToShow: 2,
                  arrows: false,
                  dots: true,
                }*/
              }
              /*{
                breakpoint: 380,
                settings: {
                  arrows: false,
                }
              }*/
          ] 
        });
    }

    /*Default products Carousel*/
    var productsSlick =  $('#products-slick'); 

    if (productsSlick.length) {
      productsSlick.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: true,
        prevArrow:"<a class='slick-prev slick-hg-prev'><span class='iconify' data-icon='ic:outline-keyboard-arrow-left' data-inline='false'></span></a>",
        nextArrow:"<a class='slick-next slick-hg-next'><span class='iconify' data-icon='ic:outline-keyboard-arrow-right' data-inline='false'></span></a>",
        responsive: [
          {
              breakpoint: 1025,
              settings: {
                /*arrows: false,*/
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 992,
              settings: {
                /*arrows: false,*/
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 768,

              settings: {
                slidesToShow: 1,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                arrows: false,
                dots: true,
              }
            }
            /*{
              breakpoint: 380,
              settings: {
                arrows: false,
              }
            }*/
        ] 

      });

    }

    /*Related products Carousel*/
    /*var productsSlick =  $('#products-slick-more'); */
    var productsRelatedSlick =  $('.related.products ul'); 

    if (productsRelatedSlick.length) {
      productsRelatedSlick.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: true,
        prevArrow:"<a class='slick-prev slick-hg-prev'><span class='iconify' data-icon='ic:outline-keyboard-arrow-left' data-inline='false'></span></a>",
        nextArrow:"<a class='slick-next slick-hg-next'><span class='iconify' data-icon='ic:outline-keyboard-arrow-right' data-inline='false'></span></a>",
        responsive: [
          {
              breakpoint: 1025,
              settings: {
                /*arrows: false,*/
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 992,
              settings: {
                /*arrows: false,*/
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 768,

              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 415,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: false,
                dots: true,
              }
            }
            /*{
              breakpoint: 380,
              settings: {
                arrows: false,
              }
            }*/
        ] 

      });

    }

    /*Brands Carousel*/
    var brandSlick =  $('#brands-slick'); 

    if (brandSlick.length) {
      brandSlick.slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: true,
        prevArrow:"<button type='button' class='brands-nav brands-nav-prev'><span class='iconify' data-icon='ic:outline-keyboard-arrow-left' data-inline='false'></span></button>",
        nextArrow:"<button type='button' class='brands-nav brands-nav-next'><span class='iconify' data-icon='ic:outline-keyboard-arrow-right' data-inline='false'></span></button>",
        responsive: [
            {
              breakpoint: 1200,
              settings: {
                /*arrows: false,*/
                slidesToShow: 5,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 980,
              settings: {
                /*arrows: false,*/
                slidesToShow: 4,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 780,
              settings: {
                /*arrows: false,*/
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 415,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                /*arrows: false,
                dots: true,*/
              }
            }
            
        ] 

      });

    }

    /*Related products Carousel*/
    var categoriesSlick =  $('.categories-slick'); 

    if (categoriesSlick.length) {
      categoriesSlick.slick({
        slidesToShow: 9,
        infinite: true,
        slidesToScroll: 3,
        speed: 300,
        autoplay: false,
        autoplaySpeed: 6000,
        arrows: true,
        prevArrow:"<a class='slick-prev slick-cat-prev'><span class='iconify' data-icon='ic:outline-keyboard-arrow-left' data-inline='false'></span></a>",
        nextArrow:"<a class='slick-next slick-cat-next'><span class='iconify' data-icon='ic:outline-keyboard-arrow-right' data-inline='false'></span></a>",
        responsive: [
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 8,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 576,
              settings: "unslick"
              /*settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }*/
            }
            
        ] 

      });

    }    

    //Component single product when btn add to cart is not visible in viewport
    function isInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)

        );
    }

    function isInViewportMinusHeader(el) {
        const rect = el.getBoundingClientRect();
        var elementHeight = el.offsetHeight;
        var headerElement = document.querySelectorAll(".dan-header");
        var headerHeight = headerElement[0].offsetHeight-elementHeight;
        return (
            rect.top >= headerHeight &&
            rect.left >= 0 &&
            rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)

        );
    }


    /*const box = document.querySelector('.single_add_to_cart_button ');*/
    const box = document.getElementById('search-parts');

    if (box) {

      document.addEventListener('scroll', function () {

          var headerElement = document.querySelectorAll(".dan-header");
          var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
          var headerHeight = headerElement[0].offsetHeight;
          var helperBar = document.getElementById("product-helper-bar");
          //if (scrollPosition > headerHeight && window.innerWidth > 1200) {
          /*if (scrollPosition > headerHeight && window.innerWidth > 1200) {*/
          if (scrollPosition > headerHeight ) {
            /*if(isInViewport(box)){*/
            if(isInViewportMinusHeader(box)){
              /*console.log('The box is visible');*/
              helperBar.classList.remove('on');
            }else{
              /*console.log('The box is not visible in the viewport');*/
              helperBar.classList.add('on');

            }
          }

      }, {
          passive: true
      });

    }

    /*Accordion*/
    $('[data-accordion]').click(function(e) {
        e.preventDefault();
        var parent = $(this).closest('.-accordion');
        /*var elParent = $(this).closest('.-accordion-item');*/

        //parent.find('.-accordion-item').removeClass('-active');

        if ( $(this).closest('.-accordion-item').hasClass('-active') ) {
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').removeClass('-active');
        }else{
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').addClass('-active');
        }
        
    });

    //Share trigger
    $('.product-social-share').click(function(){
        $(this).toggleClass('active-tgl');
    });   

    //Menu trigger
    $('.menu-trigger-btn').click(function(){
        var trigger = $(this).data('trigger');
        $('body').toggleClass('menu-visible');
        $('#'+trigger).toggleClass('nav-visible');
    });

    //Foreground close menu
    $('.toggle-menu').click(function(){
        $('body').removeClass('menu-visible');
        $('.nav-visible').removeClass('nav-visible');
    });

    //Menu trigger
    $('.cart-trigger').click(function(){
        event.preventDefault();
        if (!$(this).hasClass('-minicart-off')) {
          var trigger = $(this).data('trigger');
          /*$('body').toggleClass('cart-visible');*/
          $('#'+trigger).toggleClass('-visible');
        }
    });

    //Cart Toggle
    $('.mini-cart-toggle').click(function(){
        $('#shop-mini-cart').removeClass('-visible');
    });

    //Foreground close menu
    $('.dropdown-toggle-hover').click(function(){
      if (window.innerWidth < 769) {
        //Mobile
        event.preventDefault();
        
        /*check has class - to mobile redirect*/
        
        var parentEl = $(this).closest('.dropdown');

        if (parentEl.hasClass('open')) {
          parentEl.removeClass('open');
          $(this).find('.iconify').css('transform', 'rotate(360deg)');
        }else{
          $('.dropdown-mobile').find('.iconify').css('transform', 'rotate(360deg)');
          if (!$(this).hasClass('header-account-toggle')) {
            $(this).find('.iconify').css('transform', 'rotate(180deg)');  
          }
          
          $('.dropdown-mobile').removeClass('open');
          parentEl.addClass('open');
        }
        

      }else{
        //Desktop

      }
        /*$('body').removeClass('menu-visible');
        $('.nav-visible').removeClass('nav-visible');*/
    });

    //my account trigger
    $('.myaccount-trg').click(function(){
        $('.woocommerce-MyAccount-navigation').toggleClass('-active');
    });

    /*$('.mini-cart').on( 'click', 'button.plus, button.minus', function() {
        // Get current quantity values
        var qty = $( this ).closest( '.mini-cart-item' ).find( '.qty' );
        var val   = parseFloat(qty.val());
        var max = parseFloat(qty.attr( 'max' ));
        var min = parseFloat(qty.attr( 'min' ));
        var step = parseFloat(qty.attr( 'step' ));

        // Change the value if plus or minus
        if ( $( this ).is( '.plus' ) ) {
           if ( max && ( max <= val ) ) {
              qty.val( max );
           } 
        else {
           qty.val( val + step );
             }
        } 
        else {
           if ( min && ( min >= val ) ) {
              qty.val( min );
           } 
           else if ( val > 1 ) {
              qty.val( val - step );
           }
        }
         
    });*/

    $('form.cart').on( 'click', 'button.plus, button.minus', function() {

        
        // Get current quantity values
        var qty = $( this ).closest( '.quantity-wrap' ).find( '.qty' );
        var val   = parseFloat(qty.val());
        var max = parseFloat(qty.attr( 'max' ));
        var min = parseFloat(qty.attr( 'min' ));
        var step = parseFloat(qty.attr( 'step' ));

        // Change the value if plus or minus
        if ( $( this ).is( '.plus' ) ) {
           if ( max && ( max <= val ) ) {
              qty.val( max );
           } 
        else {
           qty.val( val + step );
             }
        } 
        else {
           if ( min && ( min >= val ) ) {
              qty.val( min );
           } 
           else if ( val > 1 ) {
              qty.val( val - step );
           }
           else if ( val == 1 ) {
            if ($( this ).closest( 'form.cart' ).hasClass('grouped_form')) {
              /*console.log('here zero trigger for grouped ')*/
              qty.val( min );
            }
           }
        }


        //Calculate Helper
        if ($( this ).closest( 'form.cart' ).hasClass('grouped_form')) {
          var allQty = $( this ).closest( 'form.cart' ).find( '.qty' );
          var allPrice = $( this ).closest( 'form.cart' ).find( '.amount bdi' );
          //console.log(allPrice);
          
          var sumEach = 0;
          var calcEach = 0;
          for (i = 0; i < allQty.length; i++) {
            var eachVal = parseInt( $(allQty[i]).val() );
            sumEach += parseInt(eachVal);

            var eachPriceField = $(allQty[i]).closest( '.grouped-item' ).find( '.amount bdi' );
            var eachPriceText = eachPriceField[0].innerText;
            var textArr = eachPriceText.split("R$");
            var eachPrice = pricetoFloat( textArr[1] );

            /*console.log(eachPrice);*/

            if (eachVal > 0) {
              calcEach += parseFloat(eachPrice) * eachVal;
            }
          }
          //console.log(sumEach)
          /*for (c = 0; c < allPrice.length; c++) { //console.log($(allPrice[c]));
            var eachText = $(allPrice[c])[0].innerText;
            var textArr = eachText.split("R$");
            var eachPrice = parseFloat( textArr[1] );
            calcEach += parseFloat(eachPrice);
          }*/

          $('#helper-products-qty').text(sumEach);
          $('#helper-products-price').text(calcEach.toFixed(2).toString().replace('.', ','));
        }

    });

    //Helper click
    $('.helper-add').click(function(){
        $('.single_add_to_cart_button').click();
    });

    /*Helper function to format price to float for calculate*/
    function pricetoFloat(price){
      var float = price.replace('.', '');
      float = parseFloat(float.trim().replace(',', '.'));
      return float;
    }




    /* Reload Cart on buttons quantity change*/
    function enable_update_cart() {
        $('[name="update_cart"]').removeAttr('disabled');
    }

    function quantity_step_btn() {
        var timeoutPlus;
        $('form.woocommerce-cart-form .quantity-wrap .plus').one().on('click', function() {
            $input = $(this).closest('.quantity-wrap').find('input.qty');
            var val = parseInt($input.val());
            var step = $input.attr('step');
            step = 'undefined' !== typeof(step) ? parseInt(step) : 1;
            $input.val( val + step ).change();

            if( timeoutPlus != undefined ) {
                clearTimeout(timeoutPlus)
            }
            timeoutPlus = setTimeout(function(){
                $('[name="update_cart"]').trigger('click');
            }, 1000);
        });

        var timeoutMinus;
        $('form.woocommerce-cart-form .quantity-wrap .minus').one().on('click', function() {
            $input = $(this).closest('.quantity-wrap').find('input.qty');
            var val = parseInt($input.val());
            var step = $input.attr('step');
            step = 'undefined' !== typeof(step) ? parseInt(step) : 1;
            if (val > 1) {
                $input.val( val - step ).change();
            }

            if( timeoutMinus != undefined ) {
                clearTimeout(timeoutMinus)
            }
            timeoutMinus = setTimeout(function(){
                $('[name="update_cart"]').trigger('click');
            }, 1000);
        });

        var timeoutInput;
        jQuery('div.woocommerce').on('change', '.qty', function(){
            if( timeoutInput != undefined ) {
                clearTimeout(timeoutInput)
            }
            timeoutInput = setTimeout(function(){
                $('[name="update_cart"]').trigger('click');
            }, 1000);
        });
    }

    $(document).ready(function() { 
        enable_update_cart();
        quantity_step_btn();
    });

    jQuery( document ).on( 'updated_cart_totals', function() {
        enable_update_cart();
        quantity_step_btn();
    }); 


    /*Minicart update*/
    function minicart_quantity_step_btn() {
        var timeoutPlus;
        $('form.component-mini-cart .quantity-wrap .plus').one().on('click', function() {
            $input = $(this).closest('.quantity-wrap').find('input.qty');
            var val = parseInt($input.val());
            var step = $input.attr('step');
            step = 'undefined' !== typeof(step) ? parseInt(step) : 1;
            $input.val( val + step ).change();

            if( timeoutPlus != undefined ) {
                clearTimeout(timeoutPlus)
            }
            timeoutPlus = setTimeout(function(){
                //$('[name="update_cart"]').trigger('click');
            }, 1000);
        });

        var timeoutMinus;
        $('form.component-mini-cart .quantity-wrap .minus').one().on('click', function() {
            $input = $(this).closest('.quantity-wrap').find('input.qty');
            var val = parseInt($input.val());
            var step = $input.attr('step');
            step = 'undefined' !== typeof(step) ? parseInt(step) : 1;
            if (val > 1) {
                $input.val( val - step ).change();
            }

            if( timeoutMinus != undefined ) {
                clearTimeout(timeoutMinus)
            }
            timeoutMinus = setTimeout(function(){
                //$('[name="update_cart"]').trigger('click');
            }, 1000);
        });

        /*var timeoutInput;
        jQuery('div.woocommerce').on('change', '.qty', function(){
            if( timeoutInput != undefined ) {
                clearTimeout(timeoutInput)
            }
            timeoutInput = setTimeout(function(){
                //$('[name="update_cart"]').trigger('click');
            }, 1000);
        });*/
    }

    $(document).ready(function() { 
        /*enable_update_cart();*/
        minicart_quantity_step_btn();
    });

    jQuery( document ).on( 'updated_cart_totals', function() {
        /*enable_update_cart();*/
        minicart_quantity_step_btn();
    });              



    /*Anchor scroll*/
    const anchors = document.querySelectorAll(".scroll-anchor");
     
    for (const anchor of anchors) {
      anchor.addEventListener("click", clickHandler);
    }
     
    function clickHandler(e) {
      e.preventDefault();
      const header = document.querySelector("header").offsetHeight;
      const href = this.getAttribute("href");
      const offsetTop = document.querySelector(href).offsetTop;
      
      scroll({
        top: offsetTop,
        behavior: "smooth"
      });
    }

    /*Date countdown*/
    var todayCountdown = $('#today-countdown');
    if (todayCountdown.length) {
      setInterval(function time(){
        var d = new Date();
        var hours = 24 - d.getHours();
        var min = 60 - d.getMinutes();
        if((min + '').length == 1){
          min = '0' + min;
        }
        var sec = 60 - d.getSeconds();
        if((sec + '').length == 1){
              sec = '0' + sec;
        }
        $('.counter-timer').html(hours+':'+min+':'+sec)
      }, 1000);

    }

    /*Pin marker Anchor scroll*/
    const PinMarkerPoint = document.querySelectorAll("[data-anchor]");
     
    for (const pinmarker of PinMarkerPoint) {
      pinmarker.addEventListener("click", callbackHandler);
    }
     
    function callbackHandler(e) {
      e.preventDefault();
      const target = this.getAttribute("data-anchor"); 
      const header = document.querySelector("header").offsetHeight;
      const href = document.getElementById('product-'+target);
      const offsetTop = href.offsetTop;

      setTimeout(function() {
        href.classList.add('highlight');
        /*click plus trigger*/
        href.getElementsByClassName("plus")[0].click();

      }, 800);

      setTimeout(function() {
        href.classList.remove('highlight');
      }, 5000);
      
      scroll({
        top: offsetTop,
        behavior: "smooth"
      });
    }

    /*Quick search*/
        /*const anchors = document.querySelectorAll(".search-for-parts");
     
    for (const anchor of anchors) {
      anchor.addEventListener("click", clickHandler);
    }
*/


    /*var inputQuicksearch = document.querySelector('#search-parts');*/
    const Quicksearchfields = document.querySelectorAll(".search-for-parts");
    var items = document.querySelectorAll('.grouped-item');

    for (const inputQuicksearch of Quicksearchfields) {
        inputQuicksearch.addEventListener('keyup', function(ev) {
          var text = ev.target.value;
          var pat = new RegExp(text, 'i');
          for (var i=0; i < items.length; i++) {
            var item = items[i];
            if (pat.test(item.innerText)) {
              /*console.log(item.innerText);*/
              item.classList.remove("opacity-fill");
            }else {
              item.classList.add("opacity-fill");
            }
          }
        });

        /*Enter*/
        inputQuicksearch.addEventListener('keypress', function(e) {
          if (e.key === 'Enter') {
            this.parentElement.nextElementSibling.firstElementChild.click();
          }

        });
    }


    //scroll on serch product submit
    $('.search-parts-btn button').click(function(){
        event.preventDefault();
        /*var input = $('#search-parts');*/

        var input = $(this).closest('.search-form').find('.search-for-parts');
        var wrapChilds = $('.product-wrap-childs');
        var header = $('.dan-header').height();
        /*var scrollTop = wrapChilds.offset().top - (header+80);*/
        var WrapChildOffset = wrapChilds.offset().top - (header+80);
        var firstFind = wrapChilds.find('.opacity-fill').length;
        var scrollTop = ( firstFind ? firstFind.first().offset().top - (header+80) : WrapChildOffset)
        var pfield = input.position();

        $('#capsalert').remove();

        if (!input.val()) {

            //caps alert HTML, edit as necessary
            input.after('<b id="capsalert" onclick="$(this).remove();">Preencha o campo</b>');
            //the css for the caps alert, modify as necessary
            $('#capsalert')
              .css('position', 'absolute')
              .css('top', (pfield.top + $(this).outerHeight() + 1) + 'px')
              .css('left', (pfield.left) + 'px')
              .css('border-radius', '5px')
              .css('padding', '5px')
              .css('cursor', 'pointer')
              .css('background-color', '#ffe599')
              .css('border', '1px solid #e6ab00');

              //the timeout for the capsalert
          setTimeout(function(){
            $('#capsalert').remove();
          },'5000');

        }else{
           $('html,body').animate({ scrollTop: scrollTop}, 300);
            setTimeout(function(){
              input.val('');
              $('.grouped-item').removeClass('opacity-fill');
            },'3000');

        }
    });
    
   

    //Sidebar filter load more
    $('.show-more-cat').click(function(){
        var each = $(this).data('each');
        var hiddenElements = $(this).closest('.sidebar-box').find('.hide-if-load-more');
        
        if (hiddenElements) {
          $(this).closest('.sidebar-box').find('.hide-if-load-more:lt('+each+')').removeClass('hide-if-load-more');  
          var recount = $(this).closest('.sidebar-box').find('.hide-if-load-more').length;
          if (recount < 1) {
            $(this).hide();  
          }
        }
        
    });

    //Sidebar filter search categories
    const QuicksearchSidebar = document.querySelectorAll(".search-sb-cat");
    var sidebarItems = document.querySelectorAll('.search-sb-item');

    for (const sibedarQuicksearch of QuicksearchSidebar) {
        sibedarQuicksearch.addEventListener('keyup', function(ev) {
          var text = ev.target.value;
          var pat = new RegExp(text, 'i');

          var closer = this.closest('.sidebar-box');
          
            for (var i=0; i < sidebarItems.length; i++) {
              var item = sidebarItems[i];
              if (text == '') {
                  closer.classList.remove('searching');
                  item.classList.remove("hide-for-filter");
                  item.classList.remove("show-for-filter");
              }else{
                closer.classList.add('searching');
                if (pat.test(item.innerText)) {
                  /*console.log(item.innerText);*/
                  item.classList.remove("hide-for-filter");
                  item.classList.add("show-for-filter");
                }else {
                  item.classList.remove("show-for-filter");
                  item.classList.add("hide-for-filter");
                }  
              }
              
            }

        });

        /*Enter*/
        /*sibedarQuicksearch.addEventListener('keypress', function(e) {
          if (e.key === 'Enter') {
            this.parentElement.nextElementSibling.firstElementChild.click();
          }

        });*/
    }


}(window.jQuery, window, document));